import type { LearningStoreState } from "@/store/learning/state";
import type { LearningStoreGetters } from "@/store/learning/getters";
import { useLearningAssessmentStore } from "@/store/learning/assessment/learningAssessmentStore";
import { LearningSkillModel } from "~~/package/mapper/learning/model/LearningSkillModel";
import { LearningTaskModel } from "~~/package/mapper/learning/model/LearningTaskModel";
import { TaskModel } from "~~/package/mapper/learning/model/TaskModel";
import { ContestModel } from "~~/package/mapper/contest/model/ContestModel";
import {
    ProSkillAssureAssessmentSetModel
} from "~~/package/mapper/proSkillAssure/model/assessment/ProSkillAssureAssessmentSetModel";

export const navigationActions = {
    getSkill(skillId: number): LearningSkillModel {
        const index = (this as LearningStoreGetters).skillList.findIndex((skill: LearningSkillModel) => skill.id === skillId);
        return index === -1 ? new LearningSkillModel() : (this as LearningStoreGetters).skillList[index];
    },
    getSkillIndex(skillId: number): number {
        return (this as LearningStoreGetters).skillList.findIndex((skill: LearningSkillModel) => skill.id === skillId);
    },
    getTaskId(taskId: number, isNext: boolean): number {
        const assessmentStore = useLearningAssessmentStore();
        let taskList: LearningTaskModel[] | TaskModel[] | ContestModel[] = [];
        if (assessmentStore.contestList.length > 0) {
            taskList = assessmentStore.contestList;
        } else if (assessmentStore.proSkillAssure.assessment.setList.length > 0) {
            taskList = assessmentStore.proSkillAssure.assessment.setList
                .map(set => set.taskList)
                .flat();
        } else {
            taskList = (this as LearningStoreGetters).taskList;
        }

        const currentIndex = taskList.findIndex(task => task.id === taskId);
        if (currentIndex === -1) return 0;
        else if (isNext) return currentIndex + 1 < taskList.length ? taskList[currentIndex + 1].id : 0;
        else return currentIndex > 0 ? taskList[currentIndex - 1].id : 0;
    },
    getNextAssessmentId(taskId: number): number {
        return useLearningAssessmentStore().getNextAssessmentId(taskId);
    },
    getNextLevelAssessmentId(taskTemplateId: number): number {
        return useLearningAssessmentStore().getNextLevelAssessmentId(taskTemplateId);
    },
    getCurrentProSkillAssureSet(taskId: number): ProSkillAssureAssessmentSetModel {
        return useLearningAssessmentStore().getCurrentProSkillAssureSet(taskId);
    },
    getCurrentProSkillAssureSetIndex(taskId: number): number {
        return useLearningAssessmentStore().getCurrentProSkillAssureSetIndex(taskId);
    }
};
